import * as React from "react"

const Team = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M4.125 4.75a1.75 1.75 0 0 1 3.187-.999 1.744 1.744 0 0 1 0 1.998 1.75 1.75 0 0 1-3.187-.999ZM5.875 2a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5Zm-.311 12H4.552a5.351 5.351 0 0 1 1.135-2.62 3.437 3.437 0 0 1 1.22.156A4.367 4.367 0 0 0 5.564 14Zm4.622 0a4.38 4.38 0 0 0-2.311-3.142l-.008-.004a4.342 4.342 0 0 0-1.992-.479A4.376 4.376 0 0 0 1.564 14H.552a5.376 5.376 0 0 1 7.323-4.24A5.372 5.372 0 0 1 11.198 14h-1.011Zm5.012 0h-1.012a4.378 4.378 0 0 0-3.624-3.571A6.404 6.404 0 0 0 9.344 9.4a5.376 5.376 0 0 1 5.854 4.6ZM8.688 2.27c.223.253.413.537.563.845a1.75 1.75 0 1 1 0 3.27c-.15.308-.34.592-.564.846a2.75 2.75 0 1 0 0-4.962Z" />
  </svg>
)

export default Team
